import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { NOT_FOR_COMMITTED } from '../../utils/committedUnit';

/**
 * The calm stand-in for a card that only makes sense for a unit still for
 * sale (sell-speed risk, days-to-sell forecast, carrying cost, Ask IronSight),
 * on the page of a committed unit. A labelled region with the card's title.
 */
export default function NotForCommitted({ title, id }) {
    const headingId = `u2na-${useId().replace(/:/g, '')}`;
    return (
        <section className="u2-card u2-na" id={id} aria-labelledby={headingId}>
            <div className="u2-c-head"><h3 id={headingId}>{title}</h3></div>
            <p className="u2-note">{NOT_FOR_COMMITTED}</p>
        </section>
    );
}

NotForCommitted.propTypes = { title: PropTypes.string.isRequired, id: PropTypes.string };
